import React, { useEffect, useState } from 'react';

import { isCubeApp } from '@helpers/Constants';
import Http from '@helpers/Http';
import userStore from '@stores/user';
import { Api } from '@apis/client';
import FridayService from '@services/friday';
import AuthModal from './AuthModal';

interface IProps {
  onClose: () => void;
  onShow: () => void;
}

const DeviceAuth = (props: IProps) => {
  const { onShow, onClose } = props;
  const [showAuthModal, setAuthModalStatus] = useState(false);
  const [contentInfo, setContentInfo] = useState(null);

  const getNoticeRecord = async () => {
    const result = await Http.post(Api.GetNotificationRecordRemindItems, {
      userUid: userStore.userInfo.uid,
    });
    if (result.data) {
      setAuthModalStatus(true);
      setContentInfo(result.data[0]);
    }

    if (!result.data?.length) {
      onClose && onClose();
    } else {
      onShow && onShow();
    }
  };

  useEffect(() => {
    if (!isCubeApp()) {
      getNoticeRecord();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlerAuth = async (isConfirm = false) => {
    await Http.post(Api.PostNotificationMarkRead, {
      recordUid: contentInfo.uid,
      hasRead: true,
    });
    const action = contentInfo.action ? JSON.parse(contentInfo.action) : {};
    const actionCallback1 = action.action1.contentCallback;
    const actionCallback2 = action.action2.contentCallback;
    await Http.post(Api.RequestActionByContentCallback, {
      tplType: contentInfo.tplType,
      tplUid: contentInfo.tplUid,
      recordUid: contentInfo.uid,
      contentCallback: isConfirm ? actionCallback1 : actionCallback2,
    });
    setAuthModalStatus(false);
    getNoticeRecord();
  };

  const cancel = async () => {
    setAuthModalStatus(false);
    FridayService.addEvent(
      'apply_for_authorization_apply_for_authorization_popup_button_click',
      { type: '拒绝' },
    );
    handlerAuth();
  };

  const confirm = async () => {
    setAuthModalStatus(false);
    FridayService.addEvent(
      'apply_for_authorization_apply_for_authorization_popup_button_click',
      { type: '同意' },
    );
    handlerAuth(true);
  };

  return (
    <>
      {showAuthModal && contentInfo ? (
        <AuthModal
          contentInfo={contentInfo}
          onConfirm={confirm}
          onClose={cancel}
        />
      ) : null}
    </>
  );
};

export default DeviceAuth;
